import { Chip, Typography } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { IJobMatching } from '@orientaction/components/Form/CreateEditAdmin/Job/type';
import { useStyles } from './style';

const DetailJobInfo = ({
  job,
  languages,
}: {
  job: IJobMatching;
  languages?: { [key: string]: string };
}) => {
  const classes = useStyles();

  return (
    <Card variant="outlined" className={classes.cardContainer}>
      <Grid container={true} spacing={2} alignItems="center" className={classes.detailRow}>
        <Grid item={true} xs={12}>
          <Typography className={classes.mainTitle}>Introduction</Typography>
        </Grid>
        <Grid item={true} xs={12}>
          <Typography className={classes.content}>{job.intro}</Typography>
        </Grid>
      </Grid>

      <Grid container={true} spacing={2} alignItems="center">
        <Grid item={true} xs={6}>
          <Typography className={classes.title}>Niveau de diplôme</Typography>
        </Grid>
        <Grid item={true} xs={6}>
          <Typography className={classes.title}>Années d&apos;expériences</Typography>
        </Grid>
        <Grid item={true} xs={6}>
          {job.degree_levels && job.degree_levels.length ? (
            job.degree_levels.map(i => <Chip className={classes.chip} label={i} key={i} />)
          ) : (
            <Typography>N/A</Typography>
          )}
        </Grid>
        <Grid item={true} xs={6}>
          {job.year_experiences && job.year_experiences.length ? (
            job.year_experiences
              .sort()
              .map(i => <Chip className={classes.chip} label={i} key={i} />)
          ) : (
            <Typography>N/A</Typography>
          )}
        </Grid>
      </Grid>

      <Grid container={true} spacing={2} alignItems="center">
        <Grid item={true} xs={6}>
          <Typography className={classes.title}>Langues parlées</Typography>
        </Grid>
        <Grid item={true} xs={6}>
          <Typography className={classes.title}>Disponibilités</Typography>
        </Grid>
        <Grid item={true} xs={6}>
          {languages && Object.keys(languages).length ? (
            Object.keys(languages).map(k => (
              <Chip
                key={k}
                className={classes.chip}
                label={`${k}:  ${languages[k]}`}
                color="secondary"
              />
            ))
          ) : (
            <Typography>N/A</Typography>
          )}
        </Grid>
        <Grid item={true} xs={6}>
          {job.disponibilities && job.disponibilities.length ? (
            job.disponibilities.map(i => <Chip className={classes.chip} label={i} key={i} />)
          ) : (
            <Typography>N/A</Typography>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};
export default DetailJobInfo;
